module.exports = "/_next/static/files/2eaaef127d70adae3e40bbb85b03a17d.png";